import { Box, Typography } from '@mui/material';
import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import type { AddAssetArgs } from '../VNFixture/VNFixture';
import VNFixture from '../VNFixture/VNFixture';
import { VNLibraryType } from '../VNLibrary/VNLibrary';

const ImageUploader = ({
  field = null,
  title = null,
  onItemSelected,
  watchField = 'tmp.itemLookup',
}: {
  field: string;
  title: string;
  onItemSelected?: (value: AddAssetArgs) => void | null;
  watchField?: string;
}) => {
  const { getValues, watch } = useFormContext();
  const images = watch(watchField);
  const config: {
    variant: 'square' | 'landscape' | 'poster' | 'banner' | 'logo';
    dimensions: string;
  } = useMemo(() => {
    switch (title) {
      case 'Poster':
        return {
          variant: 'poster',
          dimensions: '1080 x 1920',
        };
      case 'Banner':
        return {
          variant: 'banner',
          dimensions: '2400 x 600',
        };
      case 'Logo':
        return {
          variant: 'logo',
          dimensions: '330 x 330',
        };
      default:
        return {
          variant: 'landscape',
          dimensions: '1920 x 1080',
        };
    }
  }, [title]);

  return (
    <Box p={1}>
      <Box sx={{ display: 'inline-block', width: '250px' }}>
        <VNFixture
          variant={config.variant}
          field={field}
          type={VNLibraryType.Image}
          item={images?.[getValues(field)]}
          onItemSelected={onItemSelected}
          mu
        />
      </Box>
      <Typography variant="h6">{title}</Typography>
      <span style={{ color: '#4B5563 !important', fontSize: '12px !important' }}>{config.dimensions} | .png, .jpg, .jpeg</span>
    </Box>
  );
};

export default ImageUploader;
